import { Activity } from "../types";
import { createGenericFormSlice, SliceState } from "./genericFormSlice";

const formSlice = createGenericFormSlice({
  name: "activityTab",
  initialState: {} as SliceState<Activity>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const activityTabReducer = formSlice.reducer;
export default activityTabReducer;
